import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaCar } from 'react-icons/fa';
import './NotFound.css';

const NotFound = () => {
  useEffect(() => {
    document.title = 'Page Not Found | Kariyapperuma Car Sales';
    return () => { document.title = 'Kariyapperuma Car Sales'; };
  }, []);

  return (
    <div className="not-found-page">
      <div className="container">
        <div className="not-found-content">
          <FaCar className="not-found-icon" />
          <h1>404</h1>
          <h2>Page Not Found</h2>
          <p>Sorry, the page you're looking for doesn't exist.</p>
          <div className="not-found-buttons">
            <Link to="/" className="btn btn-primary btn-lg">
              Go Home
            </Link>
            <Link to="/vehicles" className="btn btn-secondary btn-lg">
              View Vehicles
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;